import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5d4b50d9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tabs"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 1,
  class: "badge"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabs, tab => {
    return _openBlock(), _createElementBlock("div", {
      key: tab.value,
      class: _normalizeClass(['tab', {
        active: tab.value == $props.modelValue
      }]),
      style: _normalizeStyle($options.computedStyle),
      ref_for: true,
      ref: `ref-${tab.value}`,
      onClick: $event => $options.onTabChange(tab)
    }, [tab.prepend ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "prepend",
      style: _normalizeStyle({
        color: tab.prepend.color,
        backgroundColor: tab.prepend.back
      })
    }, _toDisplayString(tab.prepend.value), 5)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(tab.text) + " ", 1), tab.badge ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(tab.badge), 1)) : _createCommentVNode("", true)], 14, _hoisted_2);
  }), 128))]);
}